import { useEffect, useState } from "react";
import { _FixedAssetExtraData, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean"
import { RenderForm } from "../../../../../../theme/Component/RenderForm";
import { toast } from "react-toastify";
import { Modal } from "../../../../../../theme/Component/Modal";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";

interface componentProps {
    IDFixedAssetItem: number;
    onCloseModal: Function;
}

type DataUpdate = {
    IDItem: number,
    JSONMap: any,
    IDEmployee: number,
    Since?: string,
    IDFixedAssetExtraData?: number,
}

export const FixedAssetExtraData = ({ IDFixedAssetItem, onCloseModal }: componentProps) => {

    const { instance, bean, setBean } = useDataBean(_FixedAssetExtraData);

    useEffect(() => {
        if (IDFixedAssetItem) {
            getProps();
        }
    }, [IDFixedAssetItem])

    const getProps = () => {
        const props: any = {
            IDItem: IDFixedAssetItem
        }
        instance.getFixedAssetExtraDataCatalogPorPropiedades(props, null).then(
            (resp: any[]) => {
                if (resp.length > 0) {
                    setBean(resp[0].DataBeanProperties)
                }
                console.log(resp)
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const updateProps = (propsObjet: string) => {

        let x: DataUpdate = {
            IDEmployee: _single.getAccountID(),
            IDItem: IDFixedAssetItem,
            JSONMap: propsObjet,
            IDFixedAssetExtraData: bean.IDFixedAssetExtraData ?? null,
        }

        instance.updateFixedAssetExtraData(x).then(
            (resp) => {
                toast.success("Datos Guardados")
                getProps();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <RenderForm idFormType={1} data={bean.JSONMap ? JSON.parse(bean.JSONMap) : {}} handleUpdate={(e) => {
                    const valor = e ? JSON.stringify(e) : ""
                    updateProps(valor)
                }} />
            </div>
        </div>
    )
}